import SectionTitle from '../SectionTitle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HorizontalLine from '../HorizontalLine';
import TotalPrice from './TotalPrice';
import store from '../../../../../../store';

const PricingContent = () => {
  const { t } = useTranslation();

  const onboardingInfo = store.getState().onboardingInfo;
  return (
    <>
      <SectionTitle title={t('pageSummaryPriceSectionTitle')} />
      <HorizontalLine />
      <TotalPrice
        numberOfApartments={onboardingInfo.numberOfApartments ?? 0}
        selectedProducts={onboardingInfo.selectedProducts}
      />
      <HorizontalLine />
    </>
  );
};

export default PricingContent;
